const forceBreakLongWord = (word, width, font, fontSize) => {
  const parts = [];
  let current = "";

  for (const char of word) {
    const lineWidth = font.widthOfTextAtSize(current + char, fontSize);
    if (lineWidth <= width) {
      current += char;
    } else {
      if (current) {
        parts.push(current);
      }
      current = char;
    }
  }

  if (current) {
    parts.push(current);
  }

  return parts;
};

const wrapLineByWidth = (text, width, font, fontSize) => {
  if (!text) {
    return [""];
  }

  const lines = [];
  let currentLine = "";

  for (const word of text.split(" ")) {
    const candidate = currentLine ? `${currentLine} ${word}` : word;
    const lineWidth = font.widthOfTextAtSize(candidate, fontSize);

    if (lineWidth <= width) {
      currentLine = candidate;
      continue;
    }

    if (currentLine) {
      lines.push(currentLine);
    }

    const wordWidth = font.widthOfTextAtSize(word, fontSize);
    if (wordWidth <= width) {
      currentLine = word;
    } else {
      const parts = forceBreakLongWord(word, width, font, fontSize);
      if (parts.length > 1) {
        lines.push(...parts.slice(0, -1));
        currentLine = parts[parts.length - 1];
      } else {
        currentLine = word;
      }
    }
  }

  if (currentLine) {
    lines.push(currentLine);
  }

  return lines.length > 0 ? lines : [""];
};

const breakTextIntoLines = (textContent, width, font, fontSize) => {
  const paragraphs = String(textContent).split("\n");
  const lines = [];

  for (const paragraph of paragraphs) {
    lines.push(...wrapLineByWidth(paragraph, width, font, fontSize));
  }

  return lines;
};

export const getStableTextFontSize = (position) => {
  const fontSize = parseInt(position?.options?.fontSize || 12, 10);
  return Number.isFinite(fontSize) && fontSize > 0 ? fontSize : 12;
};

export const drawTextWidgetLines = ({
  page,
  position,
  font,
  fontSize,
  widgetWidth,
  x,
  y,
  updateColorInRgb,
  compensateRotation
}) => {
  const response = position?.options?.response;
  const defaultValue = position?.options?.defaultValue;
  const textContent = response ?? defaultValue ?? "";

  if (textContent === "") {
    return;
  }

  const lines = breakTextIntoLines(textContent, widgetWidth, font, fontSize);
  const lineHeight = Math.max(fontSize + 4, 18);
  let currentY = y;

  for (const line of lines) {
    const textPosition = compensateRotation(
      page.getRotation().angle,
      x,
      currentY,
      1,
      page.getSize(),
      fontSize,
      updateColorInRgb,
      font,
      page
    );

    page.drawText(line, textPosition);
    currentY += lineHeight;
  }
};
